import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

export default function useReviewSystemV3Experiment(): {
  showReviewSummary: boolean
  showReviewFilterTags: boolean
  showReviewSummaryAndFilterTags: boolean
} {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_REVIEW_SYSTEM_V3)
  const { reviewSystemV3Enabled = false } = useStatsigDynamicLocaleConfig()

  const showReviewSummary = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_A && reviewSystemV3Enabled
  const showReviewFilterTags = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_B && reviewSystemV3Enabled
  const showReviewSummaryAndFilterTags =
    experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_C && reviewSystemV3Enabled
  return { showReviewSummary, showReviewFilterTags, showReviewSummaryAndFilterTags }
}
